/**
 *
 * @param {number} val JS timestamp
 * @param {string|undefined} resolution 'second' | 'minute' | 'hour' | 'day' | 'week' | 'month' | 'year'
 */
export const ago = (val: number, resolution = "second") => {
  val = 0 | ((Date.now() - val) / 1000);
  const length = {
    second: 60,
    minute: 60,
    hour: 24,
    day: 7,
    week: 4.35,
    month: 12,
    year: 10000,
  };

  let result: number | string = 0;
  let seen = false;
  let unit: keyof typeof length = "second";

  for (unit in length) {
    if (unit === resolution) {
      seen = true;
    }
    result = val % length[unit];
    if (!(val = 0 | (val / length[unit])) && seen) break;
  }

  return result
    ? (result - 1
        ? result + " " + unit + "s"
        : (unit === "hour" ? "an " : "a ") + unit) + " ago"
    : "just now";
};

export const timeframes = [
  {
    id: "D",
    seconds: 86400,
  },
  {
    id: "W",
    seconds: 604800,
  },
  {
    id: "M",
    seconds: 2592000,
  },
];

export const timeframeById: Record<string, (typeof timeframes)[number]> = {};
for (const timeframe of timeframes) {
  timeframeById[timeframe.id] = timeframe;
}

export const getStartDate = (offset: number) => {
  const date = new Date();
  date.setDate(date.getDate() - offset);

  if (offset > 1) {
    date.setHours(0);
    date.setMinutes(0);
    date.setSeconds(0);
  }

  return date;
};

/**
 * @param {Date} date
 */
export const prevRoundHourDate = (date: Date) => {
  const newDate = new Date(date);

  newDate.setHours(0);
  newDate.setMinutes(0);
  newDate.setSeconds(0);
  newDate.setTime(newDate.getTime() - 60 * 60 * 1000);

  return newDate;
};

/**
 * @param {Date} date
 */
export const nextRoundHourDate = (date: Date) => {
  const newDate = new Date(date);

  newDate.setHours(0);
  newDate.setMinutes(0);
  newDate.setSeconds(0);
  newDate.setTime(newDate.getTime() + 60 * 60 * 1000);

  return newDate;
};

export const getNowEndDate = () => {
  const date = new Date();

  // next round hour to increase cache hit
  date.setHours(0);
  date.setMinutes(0);
  date.setSeconds(0);
  date.setTime(date.getTime() + 60 * 60 * 1000);

  return date;
};

export const letterToSeconds = {
  w: 604800,
  d: 86400,
  h: 3600,
  m: 60,
};

export function quantisePeriod(period: string) {
  let normalizedPeriod: number | undefined;

  const normalized = Object.keys(letterToSeconds)
    .map((s) => {
      if (!period.includes(s)) {
        return undefined;
      }
      const numberPeriod = period.replace(new RegExp(`[${s}]`, "i"), "");
      normalizedPeriod = Number(numberPeriod === "" ? 1 : numberPeriod);
      return (
        normalizedPeriod * letterToSeconds[s as keyof typeof letterToSeconds]
      );
    })
    .find((t) => t != null);

  if (normalized == null) {
    return Number(period);
  }

  return normalized;
}

/**
 * Parse date format (dd/mm/yyyy) to Date object
 * @param {string} input dd/mm/yyyy
 */
export const dateStringToDate = (input: string) => {
  if (!input) {
    return null;
  }

  const [day, month, year] = input.split("/");

  return new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
};

export const getISODate = (date: Date) => {
  return date.toISOString().split("T")[0];
};
